import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47aeb62f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header_search" }
const _hoisted_3 = { class: "header_btns" }
const _hoisted_4 = { class: "tool_tip_nav" }
const _hoisted_5 = ["onClick", "data-test"]
const _hoisted_6 = { class: "tool_tip_nav" }
const _hoisted_7 = {
  key: 0,
  "data-test": "header-nav-item-child-users"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "spinner"
}
const _hoisted_10 = { class: "notification_tooltip" }

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import ToolTipButton from '@/components/organisms/ToolTipButton'
import Spinner from '@/components/atoms/Spinner'
import Icon from '@/components/atoms/Icon'
import APP from '@/js/const/app'
import IconButton from '@/components/molecules/IconButton'
import HoverToolTip from '@/components/molecules/HoverToolTip'
import i18n from '@/plugins/i18n'

type Permissions = {
  modPassword?: boolean
  debug?: boolean
  partner?: boolean
  admin?: boolean
}


import Search from './components/Search.vue'
import NotificationToolTip from './components/NotificationToolTip.vue'
import PasswordDialog from './components/PasswordDialog.vue'
import UserPermissionsDialog from './components/UserPermissionsDialog.vue'

const __default__ = {
  name: 'HeaderNav',
  components: {
    Search,
    NotificationToolTip,
    PasswordDialog,
    UserPermissionsDialog,
  },
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore()
const router = useRouter()

const logoutLoading = ref(false)
const displayPasswordDialogFlag = ref(false)
const displayUserPermissionsDialogFlag = ref(false)
const langOption = APP.SELECT_LANGUAGE_OPTIONS

const permissions = computed<Permissions | null>(() => store.getters['auth/permissions'])
const hasUnreadNotifications = computed<boolean>(
  () => store.getters['notification/hasUnreadNotifications']
)
const hasChildUser = computed<boolean>(() => store.getters['auth/hasChildUser'])

const disablePasswordNav = computed(() => {
  return !(permissions.value && permissions.value.modPassword)
})

const noPermissionText = computed(() => {
  return disablePasswordNav.value ? i18n.global.t('header_nav_main.no_permission') : ''
})

const checkLang = (lang: string) => {
  return lang === store.getters['app/langInfo']
}

const showDebugNav = computed(() => {
  return permissions.value?.debug
})

const changeLang = (lang: string) => {
  store.commit('app/setLang', lang)
}

const togglePasswordDialog = () => {
  if (disablePasswordNav.value) {
    return
  }
  displayPasswordDialogFlag.value = !displayPasswordDialogFlag.value
}

const toggleUserPermissionDialog = () => {
  displayUserPermissionsDialogFlag.value = !displayUserPermissionsDialogFlag.value
}

const logout = () => {
  logoutLoading.value = true
  store.dispatch('auth/logout').then(
    () => {
      router.push({ name: 'login' })
      logoutLoading.value = false
    },
    () => {
      logoutLoading.value = false
    }
  )
}

onMounted(() => {
  store.dispatch('tag/getTags')
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Search)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ToolTipButton), {
        icon: "language",
        useBorder: false,
        width: "130px",
        "data-test": "header-nav-language"
      }, {
        default: _withCtx(() => [
          _createElementVNode("nav", _hoisted_4, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langOption), (lang, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => (changeLang(lang.value)),
                  "data-test": 'header-nav-language-' + lang.value
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass({ blank: !checkLang(lang.value) })
                  }, [
                    (checkLang(lang.value))
                      ? (_openBlock(), _createBlock(_unref(Icon), {
                          key: 0,
                          type: "done",
                          color: "color-white",
                          size: "16"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(lang.label), 1)
                  ], 2)
                ], 8, _hoisted_5))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(ToolTipButton), {
        icon: "person",
        useBorder: false,
        width: "200px",
        onHold: logoutLoading.value,
        "data-test": "header-nav-user"
      }, {
        default: _withCtx(() => [
          _createElementVNode("nav", _hoisted_6, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: _normalizeClass({ disable_li: _unref(disablePasswordNav) }),
                onClick: togglePasswordDialog,
                "data-test": "header-nav-item-change-password"
              }, [
                _createVNode(_unref(HoverToolTip), {
                  "tool-tip-text": _unref(noPermissionText),
                  width: 210
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ disable_menu: _unref(disablePasswordNav) })
                    }, _toDisplayString(_ctx.$t('header_nav_main.change_password')), 3)
                  ]),
                  _: 1
                }, 8, ["tool-tip-text"])
              ], 2),
              _createElementVNode("li", {
                onClick: toggleUserPermissionDialog,
                "data-test": "header-nav-item-user-permission"
              }, _toDisplayString(_ctx.$t('header_nav_main.check_privileges')), 1),
              (_unref(hasChildUser))
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createVNode(_component_router_link, { to: "/child_users" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('header_nav_main.child_account_management')) + " ", 1),
                        _createVNode(_unref(Icon), {
                          class: "icon",
                          type: "keyboard_arrow_right"
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_unref(showDebugNav))
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createVNode(_component_router_link, { to: "/debug" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 開発者用デバッグ ")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", {
                class: "logout",
                onClick: logout,
                "data-test": "header-nav-item-logout"
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('header_nav_main.logout')), 1),
                (logoutLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createVNode(_unref(Spinner), {
                        color: "color-white",
                        size: "20px"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onHold"]),
      _createElementVNode("div", {
        class: _normalizeClass(["header_btns_notifications", { unread: _unref(hasUnreadNotifications) }])
      }, [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_router_link, { to: "/notification" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IconButton), {
                icon: "notifications",
                useBorder: false,
                "data-test": "header-nav-notifications"
              })
            ]),
            _: 1
          }),
          _createVNode(NotificationToolTip)
        ])
      ], 2)
    ]),
    _createVNode(UserPermissionsDialog, {
      modelValue: displayUserPermissionsDialogFlag.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayUserPermissionsDialogFlag).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(PasswordDialog, {
      modelValue: displayPasswordDialogFlag.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayPasswordDialogFlag).value = $event)),
      onClose: togglePasswordDialog
    }, null, 8, ["modelValue"])
  ]))
}
}

})